export const NOT_STARTED = "notStarted";
export const ADDING_PLAYERS = "addingPlayers";
export const BID = "bid";
export const SCORE = "score";
export const FINISHED = "finished";



// WEBPACK FOOTER //
// ./src/state/game-states.js